import React, { useState } from "react";
import Navbar from "../frontend/backend/navbar.js";
import Footer from "../frontend/backend/footer.js";
import Chatbox from "../frontend/backend/chatbox.js";
import HeaderRight from "../frontend/backend/header_right.js";
import LeftSidebar from "../frontend/backend/leftSidebar.js";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min.js";
import jwt_decode from "jwt-decode";
import axios from "axios";
import apiConfig from '../apiConfig'; 


const SlideManage = () => {
  const history = useHistory();
  const token = localStorage.getItem("jwtToken");
  const decodedToken = jwt_decode(token);
  const user_id = decodedToken.user_id;

  const [newUser, setNewUser] = useState({
    text: "",
    slideImage: "",
  });

  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!newUser.slideImage) {
      alert("Please upload an image");
      return;
    }

    if (!newUser.text.trim()) {
      alert("Please fill up slide text");
      return;
    }

    const formData = new FormData();
    formData.append("slideImage", newUser.slideImage);
    formData.append("text", newUser.text);
    formData.append("user_id", user_id);

    setLoading(true);

    axios
      .post(`${apiConfig.baseURL}/api/users/SlideManages/`, formData)
      .then((res) => {
        setLoading(false);
        if (res.status === 200) {
          alert("Slide added successfully!");
          history.push("/slide-list");
        } else {
          alert("Something went wrong.");
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
        alert("Failed to upload slide.");
      });
  };

  const handleChange = (e) => {
    setNewUser({ ...newUser, [e.target.name]: e.target.value });
  };

  const handleSlideImage = (e) => {
    const file = e.target.files[0];
    setNewUser({ ...newUser, slideImage: file });
  };

  return (
    <>
      <Navbar />
      <Chatbox />
      <HeaderRight />
      <LeftSidebar />

      <div className="content-body">
        <div className="container-fluid">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <h4 className="card-title mb-0">Slide Manage</h4>
                <Link to="/slide-list" className="btn btn-success">
                  Slide List
                </Link>
              </div>

              <div className="card-body">
                <div className="basic-form">
                  <form onSubmit={handleSubmit} encType="multipart/form-data">
                    <div className="mb-3 row">
                      <label className="col-sm-3 col-form-label">Slide Image</label>
                      <div className="col-sm-9">
                        <input
                          type="file"
                          accept=".png, .jpg, .jpeg"
                          name="slideImage"
                          className="form-control"
                          onChange={handleSlideImage}
                          disabled={loading}
                        />
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="col-sm-3 col-form-label">Slide URL</label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          placeholder="Slide URL"
                          className="form-control"
                          name="text"
                          value={newUser.text}
                          onChange={handleChange}
                          disabled={loading}
                        />
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <div className="col-sm-2">
                        <button
                          type="submit"
                          className="btn btn-primary w-100"
                          disabled={loading}
                        >
                          {loading ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>{" "}
                              Uploading...
                            </>
                          ) : (
                            "Submit"
                          )}
                        </button>
                      </div>
                    </div>
                  </form>

                  {loading && (
                    <div className="text-center mt-3">
                      <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Uploading...</span>
                      </div>
                      <p className="mt-2">Please wait, uploading slide...</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default SlideManage;
